import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

//import { Menu } from './menu.model';
//import { verticalMenuItems, horizontalMenuItems } from './menu';
import { DataService } from 'src/services/data.service';




@Injectable()
export class DigiVolunteerService {
    getGoRoute = '/api/digivolunteer';

    constructor(private location: Location, private dataService: DataService,
        private router: Router) { }    

   
        savedigi(savedigivolunteer: any) {
            return this.dataService.post('/api/savedigivolunteer', savedigivolunteer).map(response => {
                this.dataService.clearCache();
                this.dataService.clearRouteCache(this.getGoRoute);
                return response;
            });
        }

    


}